import { LucideIcon } from 'lucide-react';
import React from 'react';

export type StatProps = {
  title: string;
  value: string | number;

  // Instead of ReactNode -> accept a Lucide Icon Component
  icon?: LucideIcon;
  iconBg?: string;

  iconSize?: number; // <--- optional override
  iconStroke?: number; // <--- optional override

  change?: string;
  changeColor?: 'green' | 'red' | 'blue' | 'yellow';
};

const colorMap = {
  green: 'text-green-500',
  red: 'text-red-500',
  blue: 'text-blue-500',
  yellow: 'text-yellow-500',
} as const;

const StatCard: React.FC<StatProps> = ({
  title,
  value,
  icon: Icon,
  iconBg,
  iconSize = 40,
  iconStroke = 1,
  change,
  changeColor = 'green',
}) => {
  return (
    <div className="bg-[#F2EBEE] flex flex-col rounded-lg p-3 justify-between">
      <div className="flex justify-between items-stretch">
        <div className="flex flex-col justify-between">
          <h3 className="text-xl font-medium text-[#2B1C25]">{title}</h3>
          <p className="text-[#2B1C25] text-3xl font-bold">{value}</p>
        </div>

        {Icon && (
          <div
            className={`aspect-square p-3 flex items-center justify-center rounded-lg text-[#2B1C25] ${iconBg}`}
          >
            <Icon size={iconSize} strokeWidth={iconStroke} />
          </div>
        )}
      </div>

      {change && <p className={`text-md ${colorMap[changeColor]} italic-semibold`}>{change}</p>}
    </div>
  );
};

export default StatCard;
